<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
        <v-row>
          <v-col>
            کل:
            {{ formatRial(details?.total) }}تومان
          </v-col>
          <v-col>
            امسال:
            {{ formatRial(details?.this_year) }}تومان
          </v-col>
          <v-col>
            این ماه:
            {{ formatRial(details?.this_month) }}تومان
          </v-col>
          <v-col>
            این هفته:
            {{ formatRial(details?.this_week) }}تومان
          </v-col>

          <v-col>
            امروز:
            {{ formatRial(details?.this_day) }}تومان
          </v-col>
        </v-row>
      <v-card-title>
        نمایش تراکنش ها
        <v-spacer></v-spacer>
        <vue-persian-datetime-picker color="black" v-model="dateTimeRange"
                                     range
                                     type="date"
                                     custom-input="#dateTimeRange"
                                     auto-submit @change="getEntities"></vue-persian-datetime-picker>
        <v-text-field class="mx-1" label="بازه زمانی" v-model="dateTimeRange" id="dateTimeRange" @change="getEntities"
                      color="black">
        </v-text-field>
        <v-text-field
            label="جستجو"
            v-model="searchQuery"
            @input="debouncedSearch"
            clearable
        ></v-text-field>

        <v-spacer></v-spacer>
        <v-select
            label="تعداد در صفحه"
            :items="perPageOptions"
            v-model="transactions.per_page"
            @change="updatePerPage"
            outlined
            dense
        ></v-select>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="transactions.data"
                :items-per-page="transactions.per_page ?? 10"
                :disable-sort="false"
                hide-default-footer
                @update:sort-by="setSortBy"
                @update:sort-desc="setSortType"
            >
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="transactions.current_page"
                :length="transactions.last_page"
                circle
                @input="getEntities"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import {debounce} from 'lodash';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "TransactionIndexView",
  components: {VuePersianDatetimePicker},
  data() {
    return {
      details:null,
      dateTimeRange:null,
      loading: true,
      searchQuery: '', // Holds the search input
      sortBy: null, // Holds the current column used for sorting
      sortType: 'desc', // 'asc' or 'desc'
      transactions: {
        current_page: 1,
        per_page: 10
      },
      perPageOptions: [5, 10, 20, 50, 100], // Options for items per page
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', sortable: true},
        {text: 'هنرجو', value: 'student_name', align: 'center', sortable: true},
        {text: 'اشتراک', value: 'subscription_title', align: 'center', sortable: true},
        {text: 'مبلغ', value: 'amount', align: 'center', sortable: true},
        {text: 'نوع', value: 'type', align: 'center', sortable: true},
        {text: 'شناسه کیف پول', value: 'wallet_id', align: 'center', sortable: true},
        {text: 'شناسه هنرجو', value: 'student_id', align: 'center', sortable: true},
        {text: 'وضعیت', value: 'status', align: 'center', sortable: true},
        {text: 'روش', value: 'method', align: 'center', sortable: true},
        {text: 'تاریخ', value: 'created_at_fa', align: 'center', sortable: true},
        {text: 'شناسه پیگیری بانک', value: 'refid', align: 'center', sortable: true},
      ],
    }
  },
  mounted() {
    this.initializeDebouncedSearch();
    this.getEntities();
  },
  watch: {
    // Fetch the new data when the page changes
    'transactions.current_page': {
      handler: 'getEntities',
    }
  },
  methods: {
    formatRial(value) {
      if (!value) return '۰'; // Return zero if value is null or undefined.
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas based on thousands grouping.
    },
    // Fetch data from the API
    getEntities() {
      const params = {
        page: this.transactions.current_page,
        needle: this.searchQuery,
        sort_by: this.sortBy,
        sort_type: this.sortType,
        per_page: this.transactions.per_page,
        range:this.dateTimeRange,
      };

      this.loading = true;
      window.axios
          .get('/finance/transaction/index', {params})
          .then((res) => {
            this.getDetails()
            this.transactions = res.data.data;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.openSnackbar(err.response.data.message, "#F1416C");
          });
    },

    getDetails(){
      window.axios
          .get('/finance/transaction/details')
          .then((res) => {
            this.details = res.data.data;
          })
          .catch((err) => {
            this.loading = false;
            this.openSnackbar(err.response.data.message, "#F1416C");
          });
    },

    // Update per_page and fetch data
    updatePerPage() {
      this.transactions.current_page = 1; // Reset to the first page
      this.getEntities(); // Fetch data with the new per_page value
    },

    // Set the column to sort by and map certain fields to backend-compatible ones
    setSortBy(column) {
      // Map 'student_name' and 'subscription_name' to their corresponding backend fields
      if (column === 'student_name') {
        column = 'student_id';
      }
      if (column === 'subscription_title') {
        column = 'subscription_id';
      }

      if (column === 'created_at_fa') {
        column = 'created_at';
      }

      // Toggle sort type if the same column is clicked
      if (this.sortBy === column) {
        this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
      } else {
        // Change to a new column and reset sort type to 'asc'
        this.sortBy = column;
        this.sortType = 'asc';
      }

      this.getEntities();
    },

    // Set the sort direction (asc / desc)
    setSortType(isDescending) {
      this.sortType = isDescending ? 'desc' : 'asc';
      this.getEntities();
    },

    // Debounced search to reduce excessive API calls
    initializeDebouncedSearch() {
      this.debouncedSearch = debounce(() => {
        this.transactions.current_page = 1; // Reset pagination on search
        this.getEntities();
      }, 300);
    },
  }
};
</script>

<style scoped>

</style>